<template>
	<div class="profile-articles m-t-3" v-if="articles.length > 0">
		<h2 class="no-border no-margin new-headers" v-html="$t('profile.in_magazine', { profile_title: profile.profile_title })"></h2>


		<div class="associated-articles-carousel">
			<vueper-slides class="no-shadow" :fixed-height="true" :gap="1" :slideMultiple="true" :bullets="false" :arrows-outside="false" :visible-slides="visibleSlides" :touchable="false" :breakpoints="breakpoints" :disableArrowsOnEdges="true" :autoplay="false">
				<vueper-slide v-for="(article, index) in articles" :key="index">
					<template v-slot:content>

						<!-- Case for less than three articles -->
						<div class="row" v-if="articles.length < 3">
							<a :href="article.url" target="_blank">
								<div class="col-md-6">
									<div class="wa-responsive-image--h180 m-b-1" :style="'background-image: url('+ debugDomain + article.page_elements[0].cms_page_element_image.path + ')'"></div>
								</div>
								<div class="col-md-6">
									<h5 class="font-sans bold no-border">{{ article.title }}</h5>
									<div class="teaser-text" v-html="article.page_elements[1].text"></div>
									<i class="wa-arrow wa-arrow-medium"></i>
									{{ article.magazine.domain.capitalized_name }}
								</div>
							</a>
						</div>

						<!-- Case when there are more than two articles -->
						<div v-if="articles.length > 2">
							<a :href="article.url" target="_blank">
								<div class="wa-responsive-image--h180 m-b-1" :style="'background-image: url('+ debugDomain + article.page_elements[0].cms_page_element_image.path + ')'"></div>
								<h5 class="font-sans bold no-border">{{ article.title }}</h5>
								<div class="teaser-text" v-html="article.page_elements[1].text"></div>
								<i class="wa-arrow wa-arrow-medium"></i>
								{{ article.magazine.domain.capitalized_name }}
							</a>
						</div>
					</template>
				</vueper-slide>
			</vueper-slides>
		</div>
	</div>
</template>

<script>
import ProfilesApi from 'WaApi/Profiles';
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
	name: 'ProfileArticlesTeaser',

	components: {
		VueperSlides,
		VueperSlide
	},

	props: {
		profileId: {
			type: String,
			require: true
		}
	},

	calculated: {
		articleCount: function() {
			return this.articles.length;
		}
	},

	mounted() {
		ProfilesApi.getAssociatedArticles(this.profileId).then((result) => {
			this.articles = result.data.articles;
			this.profile = result.data.profile;

			if (this.articles.length > 2) {
				this.visibleSlides = 4;
			}
		});
	},

	beforeDestroy() {
		clearInterval(this.$options.interval);
	},

	data: () => {
		return {
			debugDomain: 'https://www.world-architects.com',
			articles: [],
			visibleSlides: 2,
			breakpoints: {
				'991': {
					visibleSlides: 1
				}
			}
		}
	}
}
</script>

<style>

.teaser-text p {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	margin-bottom: 1em;
}

.teaser-text * {
	font-weight: normal;
	font-style: normal;
	font-family: 'GeorgiaPro-Regular', serif;
}

.vueperslides__arrow {
	top: 90px;
}

.vueperslides__arrow svg, .vueperslides__arrow svg:hover {
	background-color: #000000;
	padding: 0.7em 1em;
	width: 2.7em;
	stroke-width: 2.5;
}

/* aligns arrows to the edge of the slider */
.vueperslides__arrow--prev {
	left: 0;
	padding: 0;
}

.vueperslides__arrow--next {
	right: 0;
	padding: 0;
}

/* ! this is needed to auto resize the height of the slider */
.vueperslides__track {
	position: relative;
}

.vueperslides--fixed-height {
	height: auto;
	margin-bottom: 0 !important;
}

</style>
